<template>
  <v-container grid-list-lg>
    <premioapoliceanterior ref="premioapoliceanterior"></premioapoliceanterior>
    <tipoclientecomponent ref="tipoclientecomponent"></tipoclientecomponent>
    <v-stepper
      v-model="stepAtual"
      vertical
      v-show="!premioApoliceAnterior.opened && !tipoCliente.opened"
    >
      <v-stepper-step
        step="1"
        :editable="stepAtual > 1"
        :complete="stepAtual > 1"
      >
        Dados Cadastrais
      </v-stepper-step>
      <v-stepper-content step="1">
        <dadoscadastrais ref="dadoscadastrais"></dadoscadastrais>
      </v-stepper-content>
      <v-stepper-step
        step="2"
        :editable="stepAtual > 2"
        :complete="stepAtual > 2"
      >
        Dados Operacionais
      </v-stepper-step>
      <v-stepper-content step="2">
        <dadosoperacionais ref="dadosoperacionais"></dadosoperacionais>
      </v-stepper-content>
      <v-stepper-step
        step="3"
        :editable="stepAtual > 3"
        :complete="stepAtual > 3"
      >
        Seguros Anteriores
      </v-stepper-step>
      <v-stepper-content step="3">
        <segurosanteriores ref="segurosanteriores"></segurosanteriores>
      </v-stepper-content>
      <v-stepper-step
        step="4"
        :editable="stepAtual > 4"
        :complete="stepAtual > 4"
      >
        Novo Seguro
      </v-stepper-step>
      <v-stepper-content step="4">
        <novoseguro ref="novoseguro"></novoseguro>
        <!--  <v-snackbar
        :timeout="6000"
        color="error"
        multi-line
        v-model="erroAoEnviar">
          Ocorreu um erro ao enviar o questionário.
          <v-btn dark flat @click.native="erroAoEnviar = false">Fechar</v-btn>
        </v-snackbar>
        <v-snackbar
        dark
        :timeout="10000"
        color="primary"
        multi-line
        v-model="dataVigenciaNovoSeguroAdvert">
          Preencha a data estimada para o início da vigência.
          <v-btn dark flat @click.native="dataVigenciaNovoSeguroAdvert = false">Fechar</v-btn>
        </v-snackbar>-->
        <v-snackbar
          :timeout="6000"
          :color="snackbar.sucesso ? 'success' : 'error'"
          multi-line
          v-model="snackbar.visivel"
        >
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false"
            >Fechar</v-btn
          >
        </v-snackbar>
      </v-stepper-content>
    </v-stepper>
    <div color="secondary" class="block-btn" style="position: relative" @click="abrirDialogSolicitarAjuda()">
      <v-btn
        color="secondary"
        fixed
        class="btn-hover"
        right
        bottom
        fab
        v-show="stepAtual >= 2"
      >
        <v-icon>chat</v-icon>
      </v-btn>
      <div color="secondary" v-if="stepAtual >= 2" :class="chatPrecisaAjuda ? 'mobile-precisa-ajuda' :'btn-destkop-hover'">
        <p class="ma-0">
          Precisa de ajuda?
          <br />
          Clique aqui
        </p>
      </div>
    </div>
    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogSolicitarAjuda" max-width="500px">
          <ModalSolicitarAjuda
            v-if="dialogSolicitarAjuda"
            :dialog="dialogSolicitarAjuda"
            :dadosCadastrais="buscarDadosCadastrais($refs.dadoscadastrais)"
            @fechar="dialogSolicitarAjuda = false"
          />
        </v-dialog>
      </v-layout>
    </template>
  </v-container>
</template>

<script>
import premioapoliceanterior from "@/components/pages/questionario/PremioApoliceAnterior";
import tipoclientecomponent from "@/components/pages/questionario/TipoCliente";
import dadoscadastrais from "@/components/pages/questionario/DadosCadastraisQ";
import dadosoperacionais from "@/components/pages/questionario/DadosOperacionaisQ";
import segurosanteriores from "@/components/pages/questionario/SegurosAnterioresQ";
import novoseguro from "@/components/pages/questionario/NovoSeguroQ";
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado";
import ModalSolicitarAjuda from "@/components/pages/questionario/ModalSolicitarAjuda";

export default {
  name: "Questionario",
  components: {
    premioapoliceanterior,
    tipoclientecomponent,
    dadoscadastrais,
    dadosoperacionais,
    segurosanteriores,
    novoseguro,
    ModalSolicitarAjuda,
},
  data: () => {
    return {
      protocolo: null,
      dialogSolicitarAjuda: false,
      loadingEnvio: false,
      chatPrecisaAjuda: false,
      elementVisible: null,
      //  envioFinalizado: false,
      //  erroAoEnviar: false,
      //  dataVigenciaNovoSeguroAdvert: false,
      stepAtual: 1,
      premioApoliceAnterior: {
        opened: true,
        valor: null
      },
      tipoCliente: {
        opened: false,
        valor: null
      },
      modeloDadosCadastrais: {},
      modeloDadosOperacionais: {},
      modeloSegurosAnteriores: {},
      modeloNovoSeguro: {},
      snackbar: {
        visivel: false,
        sucesso: false,
        mensagem: ""
      }
    };
  },
  computed: {
    questionarioPai: function() {
      if (this.$route.params.questionarioPai) {
        return this.$route.params.questionarioPai;
      } else {
        return null;
      }
    },
    transportadoraQuestionarioPai: function() {
      if (this.$route.params.transportadoraQuestionarioPai) {
        return this.$route.params.transportadoraQuestionarioPai;
      } else {
        return null;
      }
    },
    usuarioQuestionarioPai: function() {
      if (this.$route.params.usuarioQuestionarioPai) {
        return this.$route.params.usuarioQuestionarioPai;
      } else {
        return null;
      }
    }
  },
  watch: {
    /*  envioFinalizado: function (newValue, oldValue) {
      if(newValue == true) {
        this.go('QuestionarioFinalizado', {protocolo: this.protocolo, nome: this.modeloDadosCadastrais.usuarioSolicitante.nome});
      }
    }*/
    stepAtual: function (newValue, oldValue){
      if(this.stepAtual == 2){
        this.funcaoTimeOut();
      }
    }

  },
  mounted: function() {
    this.verificaQuestionarioBase();
  },
  methods: {
    verificaQuestionarioBase: function() {
      const self = this;
      if (self.questionarioPai != null) {
        self.$refs.dadoscadastrais.usarQuestionarioPai(
          self.transportadoraQuestionarioPai,
          self.usuarioQuestionarioPai
        );
        self.$refs.dadosoperacionais.usarQuestionarioPai(
          self.questionarioPai.dadosOperacionais
        );
        self.$refs.segurosanteriores.usarQuestionarioPai(
          self.questionarioPai.segurosAnteriores
        );
        self.$refs.novoseguro.usarQuestionarioPai(
          self.questionarioPai.novoSeguro
        );
      }
    },

    fecharDialogSolicitarAjuda() {
      this.dialogSolicitarAjuda = false;
    },

    buscarDadosCadastrais(dadosCliente) {
      if (dadosCliente) {
        const cliente = dadosCliente;
        return cliente;
      }
    },

    abrirDialogSolicitarAjuda() {
      this.dialogSolicitarAjuda = true;
    },
    passoAnterior: function() {
      const self = this;
      self.stepAtual--;
      self.resetTempoPreenchimentoStep(self.stepAtual);
    },
    proximoPasso: function() {
      const self = this;
      self.montaModeloStepPreenchido(self.stepAtual);
      self.analyticsStepUpMonitor(self.stepAtual);
      self.setTempoPreenchimentoTotalStep(self.stepAtual);
      self.stepAtual++;
      self.resetTempoPreenchimentoStep(self.stepAtual); //Todos os steps iniciam ao mesmo tempo, por isso o reset.
      //  if (self.stepAtual == 4 && self.questionarioPai != null) { self.dataVigenciaNovoSeguroAdvert = true; }
    },
    montaModeloStepPreenchido: function(step) {
      const self = this;
      switch (step) {
        case 1:
          self.modeloDadosCadastrais = self.$refs.dadoscadastrais.montaModelo();
          break;
        case 2:
          self.modeloDadosOperacionais = self.$refs.dadosoperacionais.montaModelo();
          break;
        case 3:
          self.modeloSegurosAnteriores = self.$refs.segurosanteriores.montaModelo();
          break;
        case 4:
          self.modeloNovoSeguro = self.$refs.novoseguro.montaModelo(
            self.modeloDadosCadastrais.usuarioSolicitante
          );
          break;

        default:
          break;
      }
    },
    analyticsStepUpMonitor: function(step) {
      const self = this;
      switch (step) {
        case 1:
          self.$ga.event({
            eventCategory: "Preenchimento questionário",
            eventAction: "Preencheu Dados Cadastrais",
            eventLabel:
              "E-mail user: " +
              self.modeloDadosCadastrais.usuarioSolicitante.email +
              " - preencheu step em " +
              self.getTempoPreenchimentoStep(step) +
              " minutos.",
            eventValue: 1
          });
          break;
        case 2:
          self.$ga.event({
            eventCategory: "Preenchimento questionário",
            eventAction: "Preencheu Dados Operacionais",
            eventLabel:
              "E-mail user: " +
              self.modeloDadosCadastrais.usuarioSolicitante.email +
              " - preencheu step em " +
              self.getTempoPreenchimentoStep(step) +
              " minutos.",
            eventValue: 2
          });
          break;
        case 3:
          self.$ga.event({
            eventCategory: "Preenchimento questionário",
            eventAction: "Preencheu Seguros Anteriores",
            eventLabel:
              "E-mail user: " +
              self.modeloDadosCadastrais.usuarioSolicitante.email +
              " - preencheu step em " +
              self.getTempoPreenchimentoStep(step) +
              " minutos.",
            eventValue: 3
          });
          break;
        case 4:
          self.$ga.event({
            eventCategory: "Preenchimento questionário",
            eventAction: "Preencheu Novo Seguro",
            eventLabel:
              "E-mail user: " +
              self.modeloDadosCadastrais.usuarioSolicitante.email +
              " - preencheu step em " +
              self.getTempoPreenchimentoStep(step) +
              " minutos.",
            eventValue: 4
          });
          break;

        default:
          break;
      }
    },
    analyticsQuestionarioConcluido: function() {
      const self = this;
      self.$ga.event({
        eventCategory: "Preenchimento questionário",
        eventAction: "Concluiu questionário",
        eventLabel:
          "E-mail user: " +
          self.modeloDadosCadastrais.usuarioSolicitante.email +
          " - completou em " +
          self.getTempoPreenchimentoTotalQuestionario() +
          " minutos.",
        eventValue: 5
      });
    },
    getTempoPreenchimentoStep: function(step) {
      const self = this;
      var dateTimeInicio = "";
      var dateTimeNow = new Date(); //Para exibir em String, colocar '.toLocaleString('pt-BR')' depois do Date.
      switch (step) {
        case 1:
          dateTimeInicio = self.$refs.dadoscadastrais.dataHoraInicio;
          return parseInt(
            dateTimeNow.getTime() / 1000 / 60 -
              dateTimeInicio.getTime() / 1000 / 60
          ); //Tempo em minutos
          break;
        case 2:
          dateTimeInicio = self.$refs.dadosoperacionais.dataHoraInicio;
          return parseInt(
            dateTimeNow.getTime() / 1000 / 60 -
              dateTimeInicio.getTime() / 1000 / 60
          ); //Tempo em minutos
          break;
        case 3:
          dateTimeInicio = self.$refs.segurosanteriores.dataHoraInicio;
          return parseInt(
            dateTimeNow.getTime() / 1000 / 60 -
              dateTimeInicio.getTime() / 1000 / 60
          ); //Tempo em minutos
          break;
        case 4:
          dateTimeInicio = self.$refs.novoseguro.dataHoraInicio;
          return parseInt(
            dateTimeNow.getTime() / 1000 / 60 -
              dateTimeInicio.getTime() / 1000 / 60
          ); //Tempo em minutos
          break;

        default:
          return "Tempo de preenchimento não medido";
          break;
      }
    },
    setTempoPreenchimentoTotalStep: function(step) {
      const self = this;
      switch (step) {
        case 1:
          self.$refs.dadoscadastrais.somaTempoPreenchimentoTotal();
          break;
        case 2:
          self.$refs.dadosoperacionais.somaTempoPreenchimentoTotal();
          break;
        case 3:
          self.$refs.segurosanteriores.somaTempoPreenchimentoTotal();
          break;
        case 4:
          self.$refs.novoseguro.somaTempoPreenchimentoTotal();
          break;

        default:
          break;
      }
    },
    getTempoPreenchimentoTotalQuestionario: function() {
      const self = this;
      var tempoTotalDadosCadastrais = parseInt(
        self.$refs.dadoscadastrais.tempoPreenchimentoTotal
      );
      var tempoTotalDadosOperacionais = parseInt(
        self.$refs.dadosoperacionais.tempoPreenchimentoTotal
      );
      var tempoTotalSegurosAnteriores = parseInt(
        self.$refs.segurosanteriores.tempoPreenchimentoTotal
      );
      var tempoTotalNovoSeguro = parseInt(
        self.$refs.novoseguro.tempoPreenchimentoTotal
      );
      return parseInt(
        tempoTotalDadosCadastrais +
          tempoTotalDadosOperacionais +
          tempoTotalSegurosAnteriores +
          tempoTotalNovoSeguro
      );
    },
    resetTempoPreenchimentoStep: function(step) {
      const self = this;
      switch (step) {
        case 1:
          self.$refs.dadoscadastrais.resetDataHoraInicio();
          break;
        case 2:
          self.$refs.dadosoperacionais.resetDataHoraInicio();
          break;
        case 3:
          self.$refs.segurosanteriores.resetDataHoraInicio();
          break;
        case 4:
          self.$refs.novoseguro.resetDataHoraInicio();
          break;

        default:
          break;
      }
    },

    SairAnimacaoBotaoAjuda() {
            setTimeout(() => this.elementVisible = false, 5000)
    },

    funcaoTimeOut(){
      setTimeout( ()=>{
        this.chatPrecisaAjuda = false
      }
      , 20000)
      this.chatPrecisaAjuda = true
    },

    enviaQuestionario: function() {
      const self = this;
      let modeloQuestionario = {};
      self.loadingEnvio = true;

      try {
        modeloQuestionario.premioApoliceAnterior =
          self.premioApoliceAnterior.valor;
        modeloQuestionario.idTransportadora =
          self.modeloDadosCadastrais.idTransportadora;
        modeloQuestionario.idUsuarioSolicitante =
          self.modeloDadosCadastrais.usuarioSolicitante.id;
        modeloQuestionario.dadosOperacionais = self.modeloDadosOperacionais;
        modeloQuestionario.segurosAnteriores = self.modeloSegurosAnteriores;
        modeloQuestionario.telaNova = false;
        

        self.analyticsStepUpMonitor(self.stepAtual);
        self.setTempoPreenchimentoTotalStep(self.stepAtual);
        self.analyticsQuestionarioConcluido();
        self.montaModeloStepPreenchido(self.stepAtual);
        modeloQuestionario.novoSeguro = self.modeloNovoSeguro;
        modeloQuestionario.idQuestionarioPai =
          self.questionarioPai != null ? self.questionarioPai.id : null;
        modeloQuestionario.id = null;

        if (usuarioHelper.USUARIO_LOGADO()) {
          modeloQuestionario.idUsuarioAutor = usuarioHelper.USUARIO_LOGADO().idUsuario;
        } else {
          modeloQuestionario.idUsuarioAutor =
            self.modeloDadosCadastrais.usuarioSolicitante.id;
        }

        if (usuarioHelper.USUARIO_LOGADO()) {
          modeloQuestionario.solicitacaoInterna =
            usuarioHelper.USUARIO_LOGADO().perfil.id == 2 ? false : true;
        } else {
          modeloQuestionario.solicitacaoInterna = false;
        }
      } catch (error) {
        self.snackbar.sucesso = false;
        self.snackbar.mensagem = "Ocorreu um erro ao enviar o questionário";
        self.snackbar.visivel = true;
        self.loadingEnvio = false;
      }

      if (self.modeloDadosCadastrais.usuarioNovo) {
        axios
          .post(
            `${process.env.URL_USUARIOMS}/v1/no-auth/cadastraSenha?id=${modeloQuestionario.idUsuarioSolicitante}`
          )
          .catch(error => {
            if (process.env.NODE_ENV != "production") {
              self.snackbar.sucesso = false;
              self.snackbar.mensagem = error.data.message;
              self.snackbar.visivel = true;
              self.loadingEnvio = false;
              console.error(error);
            }
          });
      }
      axios
        .post(
          `${process.env.URL_USUARIOMS}/v1/no-auth/concentimentoUsuario`,
          self.modeloDadosCadastrais.usuarioSolicitante
        )
        .catch(error => {
          if (process.env.NODE_ENV != "production") {
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = error.data.message;
            self.snackbar.visivel = true;
            self.loadingEnvio = false;
            console.error(error);
          }
        });

      axios
        .post(
          `${process.env.URL_QUESTIONARIOMS}/v1/no-auth/insereQuestionario`,
          modeloQuestionario
        )
        .then(response => {
          self.protocolo = response.data.protocolo;
          var exception = response.data.apisulBusinessException;
          if (self.protocolo === null || self.protocolo === "") {
            self.snackbar.sucesso = false;
            exception != null && process.env.NODE_ENV != "production"
              ? exception.message
              : (self.snackbar.mensagem =
                  "Ocorreu um erro ao enviar a solicitação");
            self.snackbar.visivel = true;
            self.loadingEnvio = false;
          } else if (
            exception != null &&
            process.env.NODE_ENV != "production"
          ) {
            self.snackbar.sucesso = false;
            self.snackbar.mensagem = exception.message;
            self.snackbar.visivel = true;
            self.loadingEnvio = false;
            console.error(exception.message);
          } else {
            self.snackbar.sucesso = true;
            self.snackbar.mensagem = "Solicitação enviada com sucesso";
            self.snackbar.visivel = true;
            self.go("QuestionarioFinalizado", {
              protocolo: self.protocolo,
              nome: self.modeloDadosCadastrais.usuarioSolicitante.nome
            });
            //  self.envioFinalizado = true;
          }
        })
        .catch(err => {
          self.snackbar.sucesso = false;
          self.snackbar.mensagem = "Ocorreu um erro ao enviar sua solicitação";
          self.snackbar.visivel = true;
          self.loadingEnvio = false;
        });
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    }
  }
};
</script>

<style>
.overflow-label label {
  overflow: initial;
}

.overflow-toolbar .toolbar__title {
  white-space: initial;
}

.overflow-toolbar button {
  margin-right: 0 !important;
}



@media only screen and (max-width: 992px) {
  .div-hover {
    right: 4% !important;
    width: 250px !important;
  } 
  .block-btn:hover .btn-destkop-hover {
    display: none!important;
  }
}
.btn-hover {
  bottom: 22px !important;
}
.mobile-precisa-ajuda{
  display: block;
  position: fixed;
  bottom: 22px;
  right: 18px;
  font-size: 100%;
  color: #40bccc;
  text-align: left;
  font-weight: bold;
  border: 3px solid;
  border-radius: 40px;
  height: 56px;
  width: 208px;
  transition: 0.2s ease-in-out;
  background-color: white;
}
.mobile-precisa-ajuda p, .btn-destkop-hover p {
 padding: 3px 0 0 22px;
}
.mobile-precisa-ajuda:hover{
  cursor: pointer;
}

.btn-destkop-hover {
  transition: 0.2s ease-in-out;
  position: fixed;
  bottom: 22px;
  right: 18px;
  font-size: 100%;
  color: #40bccc;
  text-align: left;
  font-weight: bold;
  border: 3px solid;
  border-radius: 40px;
  display: none;
  height: 56px;
  width: 208px;
  transition: 0.2s ease-in-out;
  cursor: pointer;
  background-color: white;
}

.block-btn:hover .btn-destkop-hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario/Questionario.vue